/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from "react";
import {Field} from "redux-form";
import {noValidation, required} from "../../../utils/my-puratos/FormUtils";
import {useI18N} from "../../my-puratos/hoc/withI18N";

interface IProps {
    name: string,
    list: {}[],
    label?: string,
    optionId?: string,
    optionValue?: string,
    maxLength?: number,
    disabled?: boolean,
    isRequired?: boolean,
    infoMsg?: string,
    errorMsg?: string,
    hasError?: boolean,
    hasHiddenField?: boolean,
    handlerInitializer?: () => void,
}

export const DropdownField: FunctionComponent<IProps> = ({name, list, label, optionId = "label", optionValue = "label", maxLength, disabled, isRequired = false, infoMsg = "", errorMsg = "", hasError = false, hasHiddenField = false, handlerInitializer}) => {

    return <Field name={name} component={DropdownInput} label={label} maxLength={maxLength} disabled={disabled}
                  list={list} validate={isRequired ? required : noValidation} required={isRequired} infoMsg={infoMsg}
                  errorMsg={errorMsg} hasError={hasError} hasHiddenField={hasHiddenField} optionId={optionId}
                  optionValue={optionValue} initializer={handlerInitializer}/>

}

const DropdownInput = ({input, meta, list, label, optionId, optionValue, maxLength, disabled, required, infoMsg, errorMsg, hasError, hasHiddenField, initializer, ...props}) => {
    const translate = useI18N();
    const error = required && ((hasError && !meta.valid) || (meta.touched && !meta.valid));

    React.useEffect(() => {
        if (initializer) {
            initializer();
        }
    }, []);

    return (
        <div className="row">
            <div className={`col-md-6 col-sm-12 form--input ${error ? "form--input__error" : ""} ${meta.active || input.value ? "form--input__content" : ""}`}>
                <select id={input.name} name={input.name} className="form-control p-select" required={required}
                        disabled={disabled} {...input} {...props}>
                    {hasHiddenField && <option key={"hidden"} value={""} disabled hidden>{required && "*"} {translate(label)}</option>}
                    {list.map((item, i) => item &&
                        <option key={`option-${i}`} value={item[optionId]}>
                            {translate(item[optionValue])}
                        </option>)}
                </select>
                <span className={"text-very-small"}>{translate(!error ? infoMsg : errorMsg)?.replace("{}", translate(label))}</span>
            </div>
        </div>
    );
}
